<div class="lab-batch-list full-width full-height">
  <ag-grid-angular #agGrid style="width: 100%; height:80vh;" class="ag-theme-balham lab-batch-list-grid" sidebar="columns"
    (cellDoubleClicked)="onCellDoubleClicked($event)"
    [gridOptions]="gridOptions">
  </ag-grid-angular>
</div>
